import Slider from "../components/Slider";
import Album from "../components/Album";

function Home() {
  return (
    <div>
      <Slider />
      <Album />
    </div>
  );
}
export default Home;
